import React from 'react';

export const CloseIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100%"
    height="100%"
    viewBox="0 0 512 512"
  >
    <title>Sulje</title>
    <path d="M297,274.5l108.4-110.2c7-7.1,10.8-16.6,10.7-26.5c-0.1-10-4.1-19.4-11.2-26.4c-14.2-14-38.9-13.8-52.9,0.4 L240,225.7L128,111.8c-14-14.2-38.6-14.4-52.9-0.4c-7.1,7-11.1,16.4-11.2,26.4c-0.1,10,3.7,19.4,10.7,26.5L183,274.5L74.6,384.7 c-7,7.1-10.8,16.5-10.7,26.5c0.1,10,4.1,19.4,11.2,26.4c7,6.9,16.4,10.7,26.2,10.7c10.1,0,19.6-4,26.7-11.2l112-113.9l112,113.9 c7.1,7.2,16.6,11.2,26.7,11.2c9.9,0,19.2-3.8,26.2-10.7c7.1-7,11.1-16.4,11.2-26.4c0.1-10-3.7-19.4-10.7-26.5L297,274.5z" />
  </svg>
);

export const Phone = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.3659 21.5149L19.7239 21.4751C21.7984 21.2446 22.9088 19.0518 21.4951 17.5162C21.3375 17.345 21.1725 17.1725 21 17C19.817 15.817 18.6341 14.9839 17.865 14.5007C17.3973 14.2068 16.7998 14.4004 16.5528 14.8944L16.1824 15.6352C15.5066 16.9868 13.9321 17.5999 12.6474 16.8044C11.6687 16.1984 10.4862 15.3346 9.30379 14.1522C7.88598 12.7344 6.89245 11.4004 6.22016 10.3395C5.41135 9.06311 6.01324 7.49338 7.36479 6.81761L8.10557 6.44721C8.59955 6.20022 8.79317 5.60266 8.49934 5.13503C8.01608 4.36593 7.18296 3.18296 6 2C5.82754 1.82754 5.65508 1.66251 5.4839 1.50492C3.94829 0.0912122 1.75544 1.2016 1.52493 3.2761L1.48514 3.6341C1.16553 6.51043 1.51653 9.43888 3.25752 11.7507C4.14338 12.927 5.35528 14.3553 7 16C8.64474 17.6447 10.0731 18.8567 11.2494 19.7425C13.5612 21.4835 16.4896 21.8345 19.3659 21.5149Z"
      fill="#DB393C"
    />
  </svg>
);

export const Calendar = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.5 5V2" stroke="#DB393C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.5 5V2" stroke="#DB393C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.5 5V2" stroke="#DB393C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="1.5" y="4" width="22" height="4" rx="2" fill="#DB393C" />
    <path d="M3.5 11V22H21.5V11" stroke="#DB393C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ExpandChevron = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 7L10 14L3 7" stroke="#DB393C" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);

export const ButtonChevron = () => (
  <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 1.5L6.5 5L3 8.5" stroke="white" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
